module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wine@2x_a69db0.jpg";